import React from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import ModulePlaceholder from 'app/components/districtModulesCommon/ModulePlaceholder';
import LoadingSkeleton from 'app/components/topNewsModule/LoadingSkeleton';
export default function TopNewsPlaceholder() {
  const {
    name
  } = useSelector(reduxSelectDistrict);
  const location = useLocation();
  const text = "Es liegen keine Meldungen in den letzten 7 Tagen vor. Hier geht es zu allen Meldungen aus dem Kreis ".concat(name, ".");
  return /*#__PURE__*/React.createElement(ModulePlaceholder, {
    text: text,
    buttonText: "Alle Meldungen anzeigen",
    link: "".concat(location.pathname, "/news"),
    "data-sentry-element": "ModulePlaceholder",
    "data-sentry-component": "TopNewsPlaceholder",
    "data-sentry-source-file": "TopNewsPlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(LoadingSkeleton, {
    "data-sentry-element": "LoadingSkeleton",
    "data-sentry-source-file": "TopNewsPlaceholder.tsx"
  }));
}